import {useSelector} from "react-redux";

export default function useGorgiasMsgDataSourceUpdateInfo() {
    const gorgiasMsgDataSource = useSelector(state => state.gorgiasMsgDataSource);
    const lastUpdatedHandleId = gorgiasMsgDataSource.lastUpdatedHandleId;
    const error = gorgiasMsgDataSource.error;
    return {lastUpdatedHandleId, error};
}
